import type { PlaybookVariable } from 'src/services/api';

type VariableMap = Record<PlaybookVariable, string>;

export const getMissingVariable = (
    snippetContents: string,
    variableMap: VariableMap,
) => {
    const variables = snippetContents.match(/{(.*?)}/g);
    if (!variables) {
        return null;
    }

    for (const variable of variables) {
        switch (variable) {
            case '{lead_first_name}':
                if (!variableMap.lead_first_name) {
                    return 'Lead first name';
                }
                break;
            case '{property_address}':
                if (!variableMap.property_address) {
                    return 'Property address';
                }
                break;
            case '{property_tour_link}':
                if (!variableMap.property_tour_link) {
                    return 'Property tour link';
                }
                break;
            case '{rent}':
                if (!variableMap.rent) {
                    return 'Rent';
                }
                break;
            case '{num_bathrooms}':
                if (!variableMap.num_bathrooms) {
                    return 'Number of bathrooms';
                }
                break;
            case '{num_bedrooms}':
                if (!variableMap.num_bedrooms) {
                    return 'Number of bedrooms';
                }
                break;
            case '{sms_signature}':
                if (!variableMap.sms_signature) {
                    return 'Sms signature';
                }
                break;
            case '{email_signature}':
                if (!variableMap.email_signature) {
                    return 'Email signature';
                }
                break;
            case '{your_name}':
                if (!variableMap.your_name) {
                    return 'Your name';
                }
                break;
            case '{your_first_name}':
                if (!variableMap.your_first_name) {
                    return 'Your first name';
                }
                break;
            case '{property_application_link}':
                if (!variableMap.property_application_link) {
                    return 'Property application link';
                }
                break;
            case '{review_link}':
                if (!variableMap.review_link) {
                    return 'Review link';
                }
                break;
            default:
                break;
        }
    }
    return null;
};

export const snippetContentsWithVariablesFilled = (
    snippetContents: string,
    variableMap: VariableMap,
) => {
    // find all variables in snippetContents
    const variables = snippetContents.match(/{(.*?)}/g);
    if (!variables) {
        return snippetContents;
    }
    let modifiedSnippetContents = snippetContents;
    variables.forEach((variable) => {
        const variableName = variable.slice(1, -1) as PlaybookVariable;
        const value = variableMap[variableName];

        if (!value) {
            return;
        }

        modifiedSnippetContents = modifiedSnippetContents.replace(
            new RegExp(variable, 'g'),
            () => value
        );
    });

    return modifiedSnippetContents;
};

/**
 * Body-only variable substitution. The composer owns the single managed signature region,
 * so the snippet path never reads, formats, or appends a signature. Playbook
 * `{email_signature}`/`{sms_signature}` variables are ordinary template content and are
 * substituted like any other variable.
 */
export const getSnippetSeededMessage = (
    snippetContents: string,
    variableMap: VariableMap,
) => snippetContentsWithVariablesFilled(snippetContents, variableMap);
